import { Container } from "../constants";
import { getFeatureConfigurationIsEnabled } from "../helper/feature-configuration-helper";

export const getTagDSTheme = (rcTheme?: string, container?: string) => {
  const recruiterNewUI = getFeatureConfigurationIsEnabled("New Design Settings", "recruiter-new-ui");
  if (!recruiterNewUI && container === Container.internal) return rcTheme;
  const candidateNewUI = getFeatureConfigurationIsEnabled("New Design Settings", "candidate-new-ui");
  if (!candidateNewUI && container === Container.public) return rcTheme;
  if (rcTheme?.includes("lhh")) return "lhh";
  if (rcTheme?.includes("pontoon")) return "pontoon";
  switch (rcTheme) {
    case "adecco-theme":
      return "adecco";
    case "akkodis-theme":
      return "akkodis";
    case "adecco-group-theme":
    default:
      return rcTheme;
  }
};
